import { createContext as e, useContext as t } from "react";
import { l as o } from "./lodash-5ofSKtz3.mjs";
const a = {
  isReadable: !1,
  setMode: o.noop
}, s = e(a), l = () => t(s);
export {
  s as r,
  l as u
};
//# sourceMappingURL=use-readable-context-BO-ExsvT.mjs.map
